import type { Address } from 'viem';
import { useBalance } from 'wagmi';

import type { OneInchToken } from '@api';

import { ONE_INCH_NATIVE_NETWORK_TOKEN_ADDRESS } from '@shared/constants/magicSwap';

interface UseTokenBalanceParams {
  address?: Address;
  chainId?: number;
  token?: OneInchToken;
}

const useTokenBalance = ({ address, chainId, token }: UseTokenBalanceParams) => {
  const tokenId = token?.id === ONE_INCH_NATIVE_NETWORK_TOKEN_ADDRESS ? undefined : token?.id;

  const { data: rawTokenBalance, ...rest } = useBalance({
    address,
    chainId,
    token: tokenId,
  });

  return {
    data: rawTokenBalance?.value,
    ...rest,
  };
};

export { useTokenBalance };
